import * as React from 'react';
import { observable, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Services
import { createNetwork } from '../../services/network';

// Types
import { IStore } from '../../store/Store';
import { INavigate } from './NetworksDialog';

// FormState
import { CreateNetworkFormState } from './NetworksDialogCreateForm';

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import Divider from '../../components/Divider';
import Icon from '../../components/Icon';
import IconButton from '../../components/IconButton';
import MobileStepper from '../../components/MobileStepper';
import Toolbar from '../../components/Toolbar';
import Typography from '../../components/Typography';

import CreateNetworkForm from './NetworksDialogCreateForm';

// Component
interface IProps {
  store?: IStore;
  navigate: INavigate;
  closeDialog: () => void;
}

class AppNewNetwork extends React.Component<IProps, {}> {
  @observable stepperIndex = 0;

  formState = new CreateNetworkFormState();

  @computed
  get isNextDisabled() {
    return false;
  }

  async createNetwork() {
    const network = await createNetwork({
      body: this.formState.gerValues()
    });

    await this.props.store!.meStore.meInitialize();
    this.props.store!.routerStore!.navigate(`${ROUTE_PATHS.APP_NETWORK}`, {
      networkId: network.networkId
    });
    this.props.closeDialog();
  }

  handleCreateFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const validation = await this.formState.state.validate();
    if (validation.hasError) {
      return;
    }
    this.createNetwork();
    this.stepperIndex += 1;
  };

  handleMobileStepperBack = () => {
    if (this.stepperIndex === 0) {
      this.props.navigate('SELECTOR');
    }
  };

  handleMobileStepperNext = async () => {
    if (this.stepperIndex >= 0) {
      const validation = await this.formState.state.validate();
      if (validation.hasError) {
        return;
      }
      this.createNetwork();
    }
  };

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Toolbar style={{ padding: '0 8px' }}>
          <IconButton
            onClick={() => this.props.navigate('SELECTOR')}
            aria-label="Close"
          >
            <Icon>arrow_back</Icon>
          </IconButton>
          <Typography type="title" color="inherit" style={{ flexGrow: 1 }}>
            Create Network
          </Typography>
          <IconButton onClick={this.props.closeDialog} aria-label="Close">
            <Icon>close</Icon>
          </IconButton>
        </Toolbar>
        <Divider />
        <Box style={{ flexGrow: 1 }} px={4} pb={4}>
          <CreateNetworkForm
            formState={this.formState}
            onSubmit={this.handleCreateFormSubmit}
          />
        </Box>
        <Divider />
        <MobileStepper
          activeStep={this.stepperIndex}
          type="dots"
          position="static"
          backButton={
            <Button dense={true} onClick={this.handleMobileStepperBack}>
              <Icon>keyboard_arrow_left</Icon>
              Back
            </Button>
          }
          nextButton={
            <Button
              dense={true}
              onClick={this.handleMobileStepperNext}
              disabled={this.isNextDisabled}
            >
              {this.stepperIndex >= 0 ? 'Create' : 'Next'}
              <Icon>keyboard_arrow_right</Icon>
            </Button>
          }
          steps={1}
        />
      </div>
    );
  }
}

export default inject('store')(observer(AppNewNetwork));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialogCreate.tsx